import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  doc,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

function LwScreen() {
  const [data, setData] = useState([]);
  const [tab, setTab] = useState("upcoming");

  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const snap = await getDocs(collection(db, "lw_tournaments"));

    const list = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));

    setData(list);
  };

  // 🔥 DELETE

  const now = new Date();

  const filtered = data.filter((t) => {
    const time = t.time?.seconds
      ? new Date(t.time.seconds * 1000)
      : new Date();

    return tab === "upcoming" ? time >= now : time < now;
  });

  return (
    <div style={container}>
      <h1>🐺 Lone Wolf 1v1 / 2v2</h1>

      {/* CREATE */}
      <button style={createBtn} onClick={() => navigate("/create-lw")}>
        ➕ Create Tournament
      </button>

      {/* TABS */}
      <div style={tabs}>
        <button
          style={tabBtn(tab === "upcoming")}
          onClick={() => setTab("upcoming")}
        >
          Upcoming
        </button>

        <button
          style={tabBtn(tab === "completed")}
          onClick={() => setTab("completed")}
        >
          Completed
        </button>
      </div>

      {/* LIST */}
      {filtered.map((t) => (
        <Card key={t.id} t={t}  navigate={navigate}/>
      ))}
    </div>
  );
}

/* ================= CARD ================= */

function Card({ t, deleteTournament, navigate })  {
  const [players, setPlayers] = useState(0);
  const [winner, setWinner] = useState(null);

  // 🔥 REALTIME PARTICIPANTS
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, `lw_tournaments/${t.id}/participants`),
      (snap) => {
        setPlayers(snap.size);
      }
    );

    return () => unsub();
  }, [t.id]);

  // 🔥 WINNER STREAM
  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, `lw_tournaments/${t.id}/winners/result`),
      (snap) => {
        const data = snap.data();
        if (data?.winners?.length) {
          setWinner(data.winners);
        }
      }
    );

    return () => unsub();
  }, [t.id]);

  const time = t.time?.seconds
    ? new Date(t.time.seconds * 1000)
    : null;

  const isCompleted = time ? time < new Date() : false;

  return (
    <div style={card}>
      <h3>{t.title}</h3>

      <p>📍 {t.map}</p>
      <p>👥 {t.totalSpots} / {players}</p>

      <p>
        ⏰ {time ? time.toLocaleString() : "No Time"}
      </p>

      {t.prizePool > 0 && (
        <p style={{ color: "green" }}>
          💰 ₹{t.prizePool}
        </p>
      )}

      {t.perKill > 0 && (
        <p style={{ color: "orange" }}>
          ⚔ ₹{t.perKill} / kill
        </p>
      )}

      {/* 🔥 WINNER */}
      {winner && (
        <div style={winnerBox}>
          <b>🏆 Winners:</b>
          {winner.slice(0, 2).map((w, i) => (
            <p key={i}>
              {w.teamName} - {w.kills} kills (₹{w.totalEarnings})
            </p>
          ))}
        </div>
      )}

      {/* ACTIONS */}
      <div style={actions}>
        <button
    onClick={() =>
      navigate("/edit", {
        state: {
          id: t.id,
          data: t,
          collectionName: "lw_tournaments",
        },
      })
    }
  >
    ✏️ Edit
  </button>
       <button
  style={smallBtn}
  onClick={() =>
    navigate("/delete", {
      state: {
        id: t.id,
        data: t,
        collectionName: "lw_tournaments",
      },
    })
  }
>
  ❌ Delete
</button>

       <button
  onClick={() =>
    navigate("/add-room", {
      state: {
        tournamentId: t.id,
        collectionType: "lw_tournaments", // 🔥 change according to screen
      },
    })
  }
>
  🏠 Room
</button>

       <button
  disabled={t.winnerDeclared}
  onClick={async () => {
    // 🔥 participants fetch
    const snap = await getDocs(
      collection(db, "lw_tournaments", t.id, "participants") // 👈 change per screen
    );

    const participantsData = snap.docs.map((d) => d.data());

    navigate("/decide-winner", {
      state: {
        tournamentId: t.id,
        participants: participantsData,
        tournamentData: t,
        collectionType: "lw_tournaments", // 👈 IMPORTANT change per type
      },
    });
  }}
  style={{
    padding: "6px 10px",
    borderRadius: 6,
    border: "none",
    cursor: t.winnerDeclared ? "not-allowed" : "pointer",
    background: t.winnerDeclared ? "#16A34A" : "#2563EB",
    color: "#fff",
  }}
>
  {t.winnerDeclared ? "✅ Winner Done" : "🏆 Decide"}
</button>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const container = {
  color: "white",
  padding: 20,
};

const createBtn = {
  background: "green",
  color: "#fff",
  padding: 10,
  border: "none",
  borderRadius: 8,
  marginBottom: 20,
};

const tabs = {
  display: "flex",
  gap: 10,
  marginBottom: 20,
};

const tabBtn = (active) => ({
  padding: "8px 14px",
  borderRadius: 20,
  border: "none",
  background: active ? "#2563EB" : "#1E2235",
  color: "#fff",
});

const card = {
  background: "#1E2235",
  padding: 15,
  borderRadius: 10,
  marginBottom: 12,
};

const actions = {
  marginTop: 10,
  display: "flex",
  gap: 10,
};

const winnerBox = {
  background: "#064e3b",
  padding: 8,
  borderRadius: 8,
  marginTop: 8,
};
const smallBtn = {
  padding: "6px 10px",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};

export default LwScreen;